export default __webpack_public_path__ + "667a130ff7676be5da676d4375d2d5d5.svg";